import './i18n'
import './styles/base.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { initFirebaseAnalytics } from '@/config/firebase'

import App from './App'
import {
  DEBUG_TOGGLES,
  isDebugEnvironment,
  useDebugStore,
} from './debug/debugStore'

// Boot the app asynchronously to avoid top-level await (fixes MSW circular dependency issue).
async function boot() {
  initFirebaseAnalytics()

  if (
    isDebugEnvironment &&
    useDebugStore.getState().getToggle(DEBUG_TOGGLES.MOCK_SERVER)
  ) {
    console.log('[boot] starting MSW...')
    const { startMockServer } = await import('@/mocks/browser')
    await startMockServer()
    console.log('[boot] MSW ready')
  }

  // Hide loader when app is ready
  const hideLoader = () => {
    document.body.classList.add('app-ready')
    const loader = document.querySelector('#app-loader')
    if (loader) {
      setTimeout(() => loader.remove(), 300)
    }
  }

  ReactDOM.createRoot(document.querySelector('#root')!).render(
    <React.StrictMode>
      <App onReady={hideLoader} />
    </React.StrictMode>
  )
}

// eslint-disable-next-line unicorn/prefer-top-level-await
boot()
